import {call, put, takeEvery, select} from 'redux-saga/effects';
import {Actions, ACTION_TYPES} from './types';
import OrganisationService from '../../services/organisation';
import { selectUserOrganisation } from '../user/selectors';
import { IDeleteOrganisationUserPayload, IOrganisationProfilePayload, IOrganisationSettings, IOrganisationUpdateCsvPayload, IOrganisationUserUpdatePayload } from '../../common/organisation';


export function* getMyOrganisation(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            OrganisationService.getMyOrganisation.bind(OrganisationService),
        )
        yield put({
            type: ACTION_TYPES.GET_MY_ORGANISATION_SUCCESS,
            payload: result,
        });
    } catch (err) {
        console.log(err)
    }

}

export function* getOrganisationProfiles(action: Actions): Object {
    const {payload} = action;
    try {
        const result = yield call(
            OrganisationService.getProfiles.bind(OrganisationService),
            String(payload)
        )
        const organisation = yield select(selectUserOrganisation);
        yield put({
            type: ACTION_TYPES.GET_MY_ORGANISATION_SUCCESS,
            payload: {
                ...organisation,
                users: result,
            }
        })
    } catch(err) {
        console.log(err);
    } 
}

export function* addProfile(action: Actions): Object {
    const payload = action.payload as IOrganisationProfilePayload;
    try {
        yield call(
            OrganisationService.addProfile.bind(OrganisationService),
            payload,
        );
        yield put({
            type: ACTION_TYPES.GET_ORGANISATION_PROFILES,
            payload: payload.alias,
        }) 
    } catch(err) {
        console.log(err);
    }
}

export function* deleteProfile(action: Actions): Object {
    const payload = action.payload as IDeleteOrganisationUserPayload;
    try {
        yield call(
            OrganisationService.deleteUser.bind(OrganisationService),
            payload,
        );
        yield put({
            type: ACTION_TYPES.GET_ORGANISATION_PROFILES,
            payload: payload.alias,
        }) 
    } catch(err) {
        console.log(err);
    }
}

export function* changeSettings(action: Actions): Object {
    const payload = action.payload as  IOrganisationSettings;
    const {name, alias, reportSettings} = yield select(selectUserOrganisation);
    const result = {};
    //@ts-expect-error
    result.name = payload.hasOwnProperty(name) ? payload.name : name;
    //@ts-expect-error
    result.alias = payload.hasOwnProperty(alias) ? payload.alias : alias;
        //@ts-expect-error
        result.reportSettings = {
            ...reportSettings,
            ...(payload.reportSettings || {}), 
        };
    try {
        yield call(
            //@ts-expect-error
            OrganisationService.changeOrganisationSettings.bind(OrganisationService),
            result,
        );
        yield put({
            type: ACTION_TYPES.GET_MY_ORGANISATION,
        }) 
    } catch(err) {
        console.log(err);
    }
}

export function* updateProfile(action: Actions): Object {
    try {
        const payload = action.payload as IOrganisationUserUpdatePayload;
        const {alias} = yield select(selectUserOrganisation);
        yield call(
            OrganisationService.updateProfile.bind(OrganisationService),
            payload,
        );
        
        yield put({
            type: ACTION_TYPES.GET_ORGANISATION_PROFILES,
            payload: alias,
        })  
    } catch (err) {
        console.log(err);
    }
}

export function* uploadProfiles(action: Actions): Object {
    try {
        const payload = action.payload as IOrganisationUpdateCsvPayload;
        const {alias} = yield select(selectUserOrganisation);
        yield call(
            OrganisationService.uploadProfiles.bind(OrganisationService),
            payload,
        );
        
        yield put({
            type: ACTION_TYPES.GET_ORGANISATION_PROFILES,
            payload: alias,
        })  
    } catch (err) {
        console.log(err);
    }
}
const userSaga = [
    takeEvery(ACTION_TYPES.GET_MY_ORGANISATION, getMyOrganisation),
    takeEvery(ACTION_TYPES.GET_ORGANISATION_PROFILES, getOrganisationProfiles),
    takeEvery(ACTION_TYPES.ADD_PROFILE, addProfile), 
    takeEvery(ACTION_TYPES.DELETE_PROFILE, deleteProfile),
    takeEvery(ACTION_TYPES.CHANGE_ORGANISATION_SETTINGS, changeSettings),
    takeEvery(ACTION_TYPES.UPDATE_PROFILE, updateProfile),
    takeEvery(ACTION_TYPES.UPDATE_PROFILES, uploadProfiles),
];

export default userSaga;
